// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2czgr","inputWrap":"Table_inputWrap__1qkjq","col":"Table_col__2edFp","bmiTooltip":"Table_bmiTooltip__37YsC"};